import "./App.css";
import React from "react";
import Forgot from "./component/forgotPassWord/forgot";
import LoginForm from "./component/loginForm";
import Dashboard from "./component/dashboard/dashboard";
import LayoutComponent from "./component/layout";
import CompanyProfile from "./component/companyProfile/companyProfile";
import AdminProfilePage from "./component/adminProfilePage/adminProfilePage"
import OfficeTiming from "./component/officeTiming/officeTiming"
import CompanyRegistrationPage from "./component/companyProfileRegistration/companyProfileRegistration";
import EmployeeDetails from "./component/employeeProfile/employeeDetails";
import PageNotFound from "./errorHandles/pageNotFound";
import CongratulationsPage from "./component/congratulationsPage/congratulationsPage";
import ServerError from "./errorHandles/serverError";
import ServerDown from "./errorHandles/serverDown";
import ServerAuthError from "./errorHandles/serverAuthError";
import EmployeeData from "./component/employeeData/employeeData";
import ChangePassword from "./component/settingPage/password";
import { FormProvider } from "./component/formContext";
import { AdminFormProvider } from "./component/adminFormContext";
import { ImageProvider } from './component/adminProfilePhotoContext';
import { CompanyLogoProvider } from "./component/companyLogoContext";
import { OfficeFormProvider } from "./component/officeFormContext";
import {
  HashRouter,
  Route,
  Routes
} from "react-router-dom";
import constants from "./utils/constants";
import Setting from "./component/settingPage/settingFeature";
import ManageLeaves from "./component/manageLeave/manageLeave";
import ScheduleLeaves from "./component/manageLeave/scheduleLeave";
import ScheduleHoliday from "./component/manageLeave/scheduleHoliday";
import { onMessageListener } from "./firebase";
import { FetchCompanyLogo } from "./component/fetchedCompanyLogo";
import RequestAttendance from "./component/requestData/requestAttendance";
import { AttendanceRequest } from "./component/requestContext";
import CompanyLevelPdf from "./component/dashboard/pdfData/companyLevelPdf";
import { AttendanceData } from "./component/companyLevelAttendanceContext";
import PdfEmployeeExportReport from "./component/employeeProfile/pdfEmployeeAttendanceReport/pdfEmployeeExportReport";
import { EmployeeAttendance } from "./component/employeeAttendance";
import PrivacyPolicy from "./component/privacyPolicy";
import BroadCast from "./component/broadcast/broadcast";
import CreateBroadCast from "./component/broadcast/createBroadcst/createBroadcast";
import BroadcastDetails from "./component/broadcast/broadcastDetail/broadcastDetail";
import EmployeeList  from "./component/markAttendance/employeeList";
import AuthenticationPage from "./component/authenticationPage/authenticationPage";
import LandingPage from "./landingPage/landingPage";

function App() {

  onMessageListener().then(payload => {
    new Notification({ title: payload.notification.title, body: payload.notification.body })
  })

  return (
    <>
      <HashRouter>
        <FormProvider>
          <AdminFormProvider>
           <AttendanceRequest>
           <FetchCompanyLogo>
          <CompanyLogoProvider>
          <ImageProvider>
              <EmployeeAttendance>
              <AttendanceData>
              <OfficeFormProvider>
                <Routes>
                  <Route exact path={constants.navigationLink.homeLink} element={<LandingPage />} />
                  <Route exact path={constants.navigationLink.loginLink} element={<LoginForm />} />
                  <Route exact path={constants.navigationLink.authentication} element={<AuthenticationPage />} />
                  <Route exact path={constants.navigationLink.PageNotFound} element={<PageNotFound />} />
                  <Route exact path={constants.navigationLink.serverDown} element={<ServerDown />} />
                  <Route exact path={constants.navigationLink.forgetPasswordLink} element={<Forgot />} />
                  <Route path={constants.navigationLink.companyRegLink} element={<CompanyRegistrationPage />} />
                  <Route path={constants.navigationLink.adminProfileLink} element={<AdminProfilePage />} />
                  <Route path={constants.navigationLink.officeTimingLink} element={<OfficeTiming />} />
                  <Route path={constants.navigationLink.congrats} element={<CongratulationsPage />} />
                  <Route path={constants.navigationLink.serverAuthError} element={<ServerAuthError />} />
                  <Route path={constants.navigationLink.companyLevelPdfExport} element={<CompanyLevelPdf />} />
                  <Route path={constants.navigationLink.employeeAttendancePreview} element={<PdfEmployeeExportReport />} />
                  <Route path={constants.navigationLink.privacyPolicy} element={<PrivacyPolicy />} />
                  
                  <Route element={<LayoutComponent />}>
                    <Route path={constants.navigationLink.dashboardLink} element={<Dashboard />} />
                    <Route path={constants.navigationLink.companyProfileLink} element={<CompanyProfile />} />
                    <Route path={constants.navigationLink.empProfile} element={<EmployeeDetails />} />
                    <Route path={constants.navigationLink.serverError} element={<ServerError />} />
                    <Route path={constants.navigationLink.employeeData} element={<EmployeeData />} />
                    <Route path={constants.navigationLink.setting} element={<Setting />} />
                    <Route path={constants.navigationLink.changePassword} element={<ChangePassword />} />
                    <Route path={constants.navigationLink.manageLeaves} element={<ManageLeaves />} />
                    <Route path={constants.navigationLink.scheduleLeaves} element={<ScheduleLeaves />} />
                    <Route path={constants.navigationLink.scheduleHoliday} element={<ScheduleHoliday />} />
                    <Route path={constants.navigationLink.requestsAttendance} element={<RequestAttendance />} />
                    <Route path={constants.navigationLink.broadcast} element={<BroadCast />} />
                    <Route path={constants.navigationLink.createBroadCast} element={<CreateBroadCast />} />
                    <Route path={constants.navigationLink.detailBroadcast} element={<BroadcastDetails />} />
                    <Route path={constants.navigationLink.markAttendance} element={<EmployeeList />} />
                  </Route>
                </Routes>
              </OfficeFormProvider>
              </AttendanceData>
              </EmployeeAttendance>
            </ImageProvider>
          </CompanyLogoProvider>
          </FetchCompanyLogo>
           </AttendanceRequest>
          </AdminFormProvider>
        </FormProvider>
      </HashRouter>
    </>
  );
}
export default App;